<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            color="primary"
            small
            text
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
          >
            <v-icon small>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <span>More Actions</span>
      </v-tooltip>
    </template>
    <v-list>
      <manage-reports-modal v-if="programView == 'SEIT'"></manage-reports-modal>
      <template v-for="report in reportTypes">
        <v-list-item
          v-if="report.show"
          :key="report.id"
          @click="downloadReport(report)"
          ><v-icon class="mr-2">{{ report.icon }}</v-icon
          >{{ report.name }}
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import ManageReportsModal from "./manage-reports-modal.vue";
import { downloadFile } from "../../utils/download-utils";
export default {
  components: {
    ManageReportsModal,
  },
  computed: {
    programView() {
      return this.$store.state.reportsModule.programView;
    },
    reportTypes() {
      return [
        {
          id: 1,
          name: "Export Report Assignments",
          icon: "mdi-file-export-outline",
          action: "reportsModule/exportReportAssignments",
          show: this.programView == "SEIT",
          fileName: `${this.programView} Report Assignments`,
        },
        {
          id: 2,
          name: "Export Roster",
          icon: "mdi-file-table-outline",
          action: "reportsModule/getReportAssignmentRoster",
          show: this.programView == "SEIT",
          fileName: `${this.programView} Report Assignment Roster`,
        },
        {
          id: 3,
          name: `Export ${this.programView} Goals Exception Report`,
          icon: "mdi-file-alert-outline",
          action: "optionsModule/getGoalsExceptionReport",
          show: true,
          fileName: `${this.programView} Goals Exception Report`,
        },
        {
          id: 4,
          name: "Export Multiple Per Quarter Report",
          icon: "mdi-file-document-outline",
          action:
            "reportsModule/getClientsWithMultipleReportAssignmentsPerQuarter",
          show: this.programView == "SEIT",
          fileName: `${this.programView} Clients With Multiple Report Assignments Per Quarter Report`,
        },
      ];
    },
  },
  methods: {
    async downloadReport(report) {
      this.$store.commit("uxModule/setShowLoader", true);
      var response = await this.$store.dispatch(report.action);

      if (response) {
        await downloadFile(response, `${report.fileName}.csv`);
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Oops! Something went wrong. Please try again later."
        );
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
      this.$store.commit("uxModule/setShowLoader", false);
    },
  },
};
</script>
